export const saveFile = (name: string, type: string, data: BlobPart) => {
    if (!data) return;
    const objUrl = window.URL.createObjectURL(new Blob([data], { type: type || "application/octet-stream" }));
    const a = document.createElement("a");

    a.setAttribute("href", objUrl);
    a.setAttribute("download", name);

    document.body.append(a);
    a.click();
    document.body.removeChild(a);

    window.URL.revokeObjectURL(objUrl);
};

export const saveFileFromUrl = async (name: string, url: string) => {
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", name);
    a.click();
    document.body.removeChild(a);
};
